import { Drawer, DrawerBody, DrawerContent, Flex, IconButton, Menu, Text, useDisclosure } from "@chakra-ui/react"
import { filterConstants, tabs } from "../../../../../../common/constants/search-constants"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"
import { Tab } from "../../../../../../common/types/global"
import { FhResponseData } from "../../../../../../common/types/search"
import { isFilterOptionToBeRemoved } from "../../../../../../common/utils/search-utils"
import { CArrowLeft } from "../../../../../shared/Icons"
import FilterButton from "./FilterButton/FilterButton"
import FilterOptions from "./FilterOptions/FilterOptions"

type Props = {
  filterData: FhResponseData
  breadcrumbFilters: FhResponseData
  selectedTab: Tab
  showFiltersNoResultsView: boolean
  /* Optional props from the mobile overlay window component */
  isOverlayFilters?: boolean
  closeFiltersOverlay?: () => void
  rid: string
}

/* This is the mobile filters component */
const MobileFilter = ({
  filterData,
  breadcrumbFilters,
  selectedTab,
  showFiltersNoResultsView,
  isOverlayFilters,
  closeFiltersOverlay,
  rid,
}: Props) => {
  const { t } = useBrandedTranslation()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { title, filtersection, basetype } = filterData
  const isBasetypeSetOrList = basetype === filterConstants.SET || basetype === filterConstants.LIST

  /* Remove filter if nr is 0 or basetype is set or list and name === value
   Comment from PBI why we have the second check: Fredhopper expects to have translations for all created value IDs per product
   in all locales and at the moment thats not the case, so we hide them for now */
  const filteredFiltersection = filtersection.filter(
    (filterOption: FhResponseData) =>
      !isFilterOptionToBeRemoved(filterOption, isBasetypeSetOrList, showFiltersNoResultsView)
  )

  const isFilterSelected = filteredFiltersection.some((filter: FhResponseData) => filter.selected)

  /* Determine the header text based on selected tab */
  const headerLabel =
    selectedTab === tabs.PRO ? t("search-filter-filter-products-by") : t("search-filter-filter-spare-parts-by")

  return (
    <>
      <FilterButton
        title={title}
        isOpen={isOpen}
        isFilterSelected={isFilterSelected}
        isOverlayFilters={isOverlayFilters}
        onClick={onOpen}
        aria-label={`Open ${title} filter`}
      />

      <Drawer placement="right" onClose={onClose} isOpen={isOpen} size="full">
        <DrawerContent height="100dvh">
          <Flex
            as="header"
            pl={{ base: "0.5", sm: "2.5" }}
            pr={{ base: "4", sm: "6" }}
            minH="15"
            gap="2"
            fontSize="sm"
            bgColor="gray.200"
            alignItems="center"
            justifyContent="space-between"
          >
            <IconButton
              icon={<CArrowLeft />}
              bg="transparent"
              aria-label={`Close ${title} filter`}
              boxSize="12"
              onClick={onClose}
              _focusVisible={{}}
            />
            <Text textAlign="end" noOfLines={2}>
              <Text as="span" mr="1">
                {headerLabel}
              </Text>
              <Text as="span" fontWeight="bold">
                {title}
              </Text>
            </Text>
          </Flex>
          <DrawerBody px="0" py="4" fontSize="sm" position="relative">
            <Menu isOpen={isOpen}>
              <FilterOptions
                filterData={filterData}
                breadcrumbFilters={breadcrumbFilters}
                showFiltersNoResultsView={showFiltersNoResultsView}
                handleOnClose={onClose}
                isOverlayFilters={isOverlayFilters}
                closeFiltersOverlay={closeFiltersOverlay}
                rid={rid}
              />
            </Menu>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default MobileFilter
